export const defaultExcelInvoice = {
  company: {
    name: "Zylker Electronics India Pvt Ltd",
    address: "14B, Nehru Nagar, Andheri East, Mumbai, Maharashtra - 400069",
    gstin: "27AAACZ1234F1Z5",
    phone: "+91 98765 43210",
    email: "billing@zylkerindia.com"
  },
  invoice: {
    number: "INV-IND-1001",
    date: "05-08-2024",
    terms: "Due on Receipt",
    dueDate: "05-08-2024"
  },
  client: {
    name: "Rahul Traders",
    address: "Shop No 22, MG Road, Indore, Madhya Pradesh - 452001"
  },
  shipTo: {
    name: "Rahul Traders Warehouse",
    address: "Plot 18, Industrial Area, Indore - 452010"
  },
  items: [
    { desc: "Laptop", subDesc: "Business Series", qty: 2, rate: 45000 },
    { desc: "Wireless Mouse", subDesc: "Ergonomic", qty: 5, rate: 800 },
    { desc: "Keyboard", subDesc: "Mechanical", qty: 3, rate: 2500 }
  ],
  summary: {
    taxRate: 18
  }
};
